import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private url = environment.baseUrl;

  constructor(private _http: HttpClient, private _auth: AuthService) {
    if(this._auth.userToken){
      this.getUserInfo();
    }
   }

  public userInfo: any = null;

  getHeaders = () => {
    return new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this._auth.userToken
    });
  }

  getUserInfo(){
    return this._http.get<any>(this.url+'/user', {headers: this.getHeaders()});
  }

  setUserInfo(info: any): void {
    if(info.subscriptions && typeof info.subscriptions === "string"){
      info.subscriptions = JSON.parse(info.subscriptions);
    }
    this.userInfo = info;
  }

  updateUser(name?: string, surname?: string, alias?: string, lang?: string): Observable<any> {
    let body = {
        name,
        last_name: surname,
        alias,
        language: lang
    }

    return this._http.put<any>(this.url+'/user/', JSON.stringify(body), {headers: this.getHeaders()});
  }

  assignDevice(body: any): Observable<any> {
    return this._http.post<any>(this.url + '/user/addDevice', JSON.stringify(body), { headers: this.getHeaders() });
  }

  generateToken(){
    return this._http.post<any>(this.url + '/user/token', {}, { headers: this.getHeaders() });
  }

  getUserPATToken(){
    return this._http.get<any>(this.url + '/user/token', { headers: this.getHeaders() });
  }

  deleteUserPATToken(token: string): Observable<any> {
    return this._http.delete<any>(this.url + '/user/token/'+token, { headers: this.getHeaders() });
  }

  askDeveloperMode() {
    return this._http.post<any>(this.url + '/user/developer', {}, { headers: this.getHeaders() });
  }

  verifyUserByAdministrator(oobCode: string, apiKey: string, name: string, lastName: string, language: string) {
    const payload = {
      oobCode: oobCode,
      apiKey: apiKey,
      userData: {
        name: name,
        last_name: lastName,
        language: language
      }
    };

    return this._http.post<any>(
      `${this.url}/user`,
      payload
    );
  }

  unsubscribeAsTester(email: string): Observable<any> {
    return this._http.delete<any>(this.url + '/user/tester', { headers: this.getHeaders() });
  }
  requestTester(email: string, language: string): Observable<any> {
    let body = {
      email : email,
      language : language
    }
    return this._http.post<any>(this.url + '/user/tester', JSON.stringify(body), { headers: this.getHeaders() });
  }

  getTesters(){
    return this._http.get<any>(this.url + '/user/tester', { headers: this.getHeaders() });
  }

  downgradeTesters(testers: any[]){
    let body = {
      testers : testers
    }
    return this._http.put<any>(this.url + '/user/tester/downgrade', JSON.stringify(body), { headers: this.getHeaders() });
  }

  confirmTesters(testers: any[]){
    let body = {
      testers : testers
    }
    return this._http.put<any>(this.url + '/user/tester/confirm', JSON.stringify(body), { headers: this.getHeaders() });
  }

  resendTelegramInviteLink(testers: any[]){
    let body = {
      testers : testers
    }
    return this._http.post<any>(this.url + '/user/tester/telegram-invite', JSON.stringify(body), { headers: this.getHeaders() });
  }

  getUserInfoGetted(){
    return this.userInfo;
  }

  hasGroupsSubscription(): boolean {
    return this.userInfo?.subscriptions?.some((sub: any) => sub.type === 'groups') || false;
  }
}
